import {Component, OnInit} from '@angular/core';
import {CustomerContextService} from '../../service/customer-context-service';
import {Observable} from 'rxjs';
import {CustomerContact, Ref, UserAuthService} from '@lifeislife/lifeislife-domain';
import {Router} from '@angular/router';

@Component({
  selector: 'cf-customer-contact-select-modal',
  templateUrl: './customer-contact-select-modal.component.html',
  styleUrls: ['./customer-contact-select-modal.component.scss'],
})
export class CustomerContactSelectModalComponent implements OnInit {

  availableRefs$: Observable<Ref<CustomerContact>[]>;

  constructor(
    private customerContextService: CustomerContextService,
    private userAuthService: UserAuthService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.availableRefs$ = this.customerContextService.availableCustomerContacts$.pipe(

    );
  }

  onCustomerContactSelect(ref: Ref<CustomerContact>) {
    this.customerContextService.selectCustomerContactRef(ref);
  }

  onLogoutClick() {
    this.userAuthService.deauthenticate();
  }
}
